package com.kinoshazam.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.kinoshazam.uiKit.webView.UiKitWebView
import org.koin.compose.viewmodel.koinViewModel
import presentation.screens.webPlayer.WebPlayerMVIAction
import presentation.screens.webPlayer.WebPlayerState
import presentation.screens.webPlayer.WebPlayerViewModel

@Composable
fun WebPlayerHost() {
    val viewModel = koinViewModel<WebPlayerViewModel>()
    val state by viewModel.state.collectAsStateWithLifecycle()
    WebPlayerContent(
        state = state,
        onAction = viewModel::onAction,
    )
}


@Composable
private fun WebPlayerContent(
    state: WebPlayerState,
    onAction: (WebPlayerMVIAction) -> Unit,
) {
    // Do NOT wrap in Material3 Scaffold/Surface: Surface uses offscreen compositing and
    // blanks WebView HTML5 video (SurfaceView) while audio keeps playing.
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black),
    ) {
        UiKitWebView(
            url = state.videoUrl,
            onAction = onAction,
            title = state.title,
            resumePositionSec = state.resumePositionSec,
            resumeAudio = state.resumeAudio,
            resumeQuality = state.resumeQuality,
            resumeSubtitles = state.resumeSubtitles,
            playbackChoiceReady = state.playbackChoiceReady,
            onPlaybackChoice = { audio, quality, subtitles ->
                onAction(
                    WebPlayerMVIAction.PlaybackChoiceChanged(
                        audio = audio,
                        quality = quality,
                        subtitles = subtitles,
                    )
                )
            },
            onProgress = { positionSec, durationSec, paused ->
                onAction(
                    WebPlayerMVIAction.ProgressSample(
                        positionSec = positionSec,
                        durationSec = durationSec,
                        paused = paused,
                    )
                )
            },
        )
    }
}
